import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSubscription } from "../context/SubscriptionContext";

export default function SuccessPage() {
  const { setIsPro } = useSubscription();

  useEffect(() => {
    // Set Pro status on successful payment
    localStorage.setItem("paywatch_pro", "true");
    setIsPro(true);
  }, []);

  return (
    <main className="max-w-2xl mx-auto px-4 py-20 text-center">
      <div className="text-6xl mb-6">🎉</div>
      <h1 className="font-display text-4xl text-white mb-4">
        Welcome to <span className="text-gold-400">Pro!</span>
      </h1>
      <p className="text-white/60 mb-8">
        Your subscription is active. You now have access to all Pro features including
        unlimited searches, provider comparison, CSV export, and more.
      </p>
      <Link to="/" className="btn-primary px-8 py-3">
        Start searching →
      </Link>
    </main>
  );
}